// extracted by mini-css-extract-plugin
export var button = "_iu-2";
export var card = "_iu-0";
export var closeButtonContainer = "_iu-3";
export var iconContainer = "_iu-1";